import { ref } from 'vue'
// import ErrorHandler from 'helpers/errorHandler'
import * as Sentry from '@sentry/vue'
import { Dialog } from 'quasar'

const op = ref({
  current: null
})

let handlers = {}
let showingAuthDialog = false

export const promptReauthentication = () => {
  if (showingAuthDialog) {
    console.warn('skipping duplicate call for reauthentication dialog')
    return
  }
  showingAuthDialog = true
  Dialog.create({
    title: 'Sitzung abgelaufen',
    message: 'Aufgrund von zu langer Inaktivität müssen Sie sich erneut anmelden.',
    class: 'reauthentication-dialog'
  }).onDismiss(() => {
    showingAuthDialog = false
    window.location.href = `session/revoke?redirect=${window.location.href}`
  })
}

const unauthorizedAutoRetry = () => {
  if (sessionStorage.getItem('order.revoked') === 'true') {
    console.warn('auto recovery from 401 failed')
    sessionStorage.removeItem('order.revoked')
    return
  }
  console.log('trying to automatically recover from unauthorized request by revocation')
  sessionStorage.setItem('order.revoked', true)
  window.location.href = `session/revoke?redirect=${window.location.href}`
}

export default ({ app }) => {
  app.config.globalProperties.$errorPage = op

  handlers = {
    vue: {
      default: (err) => {
        console.warn(err)
        op.value.current = 'OrderError'
      }
    },
    graphql: ({ operation, networkError, graphqlErrors, response }) => {
      if (!operation.getContext().skipUnauthorizedHandling && networkError?.statusCode === 401) {
        if (operation.getContext().showUnauthorizedDialog) {
          promptReauthentication()
          return
        } else {
          unauthorizedAutoRetry()
          return
        }
      }

      Sentry.captureException(new Error('Graphql query failed'), scope => {
        scope.setExtras({
          networkError: JSON.stringify(networkError),
          graphqlErrors: JSON.stringify(graphqlErrors),
          responseErrors: JSON.stringify(response?.errors)
        })
      })

      if (operation.getContext().skipGlobalErrorHandling) {
        return
      }

      if (networkError && networkError.statusCode >= 500 && networkError.statusCode <= 599) {
        op.value.current = {
          name: 'OrderError',
          props: {
            message: 'Unsere Server können diese Anfrage gerade nicht verarbeiten.<br/>Bitte versuchen Sie es später erneut'
          }
        }
      } else {
        op.value.current = 'OrderError'
      }
    },
    global: {
      default: (err) => {
        if (err.message !== 'ResizeObserver loop limit exceeded') {
          console.warn(err)
        }
      }
    }
  }

  // app.use(ErrorHandler, { handlers })
}

export { handlers, op as errorPage }
export function setCurrentErrorPage (v) {
  op.value.current = v
}
